export class EventCounter{
    nombre: string;
    secuencia: string;
    descripcion: string;
    valor: string;
    cantidad: Number;
}